import { logger as r } from "../../shared-lib/index.js";
export function setLogger(e) {
  r.setLogger(e);
}
